'use client';
import { EquipmetActionButtonWrapperProps } from '../../../types';
import { MY_EQP_SCHEMA } from 'components/my-equipment/constants';
import { actionTypes } from 'components/my-equipment/types';
import styles from '../../../customer-account.module.scss';
import { Conditional } from 'components/pcc-components';
import cx from 'classnames';
import { MyEquipmentActionMenu } from 'components/my-equipment/my-equipment-action-menu';
import { getRFSEnabledUser } from 'components/request-equipment-service/utils';
import { GA_CONTEXT_TEXT } from 'constants/analyticsConstants';

export const EquipmetActionButtonWrapper = ({
  equipmentDetails,
  userDetail,
  isRequestServiceForIAFlag,
  selectedEquipmentIndex,
  startTransition,
  isPending,
  isAssetLandingFeatureFlag
}: Readonly<EquipmetActionButtonWrapperProps>) => {
  const isRequestService = getRFSEnabledUser(
    userDetail,
    isRequestServiceForIAFlag
  );

  const isSelectedEquipment = selectedEquipmentIndex > -1;

  const actionItems: Array<actionTypes> = [
    {
      id: MY_EQP_SCHEMA.VIEW_DASHBOARD
    },
    {
      id: MY_EQP_SCHEMA.SHOP_PARTS
    },
    {
      id: MY_EQP_SCHEMA.CAT_PARTS_DIAGRAM
    },
    {
      id: MY_EQP_SCHEMA.MORE,
      moreOptions: [
        {
          id: MY_EQP_SCHEMA.REQUEST_SERVICE,
          isActionVisible: isRequestService
        },
        {
          id: MY_EQP_SCHEMA.ALP_MAINTENANCE_REPAIRS,
          classNames: cx([styles['contextualmenu-wrapper__list-item']])
        },
        {
          id: MY_EQP_SCHEMA.CLEAR_SELECTION,
          isActionVisible: isSelectedEquipment
        },
        {
          id: MY_EQP_SCHEMA.PLEASE_SELECT,
          isActionVisible: !isSelectedEquipment
        },
        {
          id: MY_EQP_SCHEMA.EDIT
        },
        {
          id: MY_EQP_SCHEMA.DELETE,
          isActionVisible: !equipmentDetails.isValidatedAsset
        }
      ]
    }
  ];

  return (
    <div className={cx(styles['action-card-container'])}>
      <Conditional test={!isPending}>
        <MyEquipmentActionMenu
          actionItems={actionItems}
          equipmentDetails={equipmentDetails}
          userDetail={userDetail}
          isDetailsCard
          startTransition={startTransition}
          isRequestServiceForIAFlag={isRequestServiceForIAFlag}
          gaContext={GA_CONTEXT_TEXT}
          isAssetLandingFeatureFlag={isAssetLandingFeatureFlag}
        />
      </Conditional>
    </div>
  );
};
